import * as React from "react"
import { setCookie } from "../../custom_utils/cookies"
import { PREF_BRANCH_COOKIE_TOAST } from "./Localization/LocalizationState"

export type ToastProps = {
  show: string
}
export type ToastState = {
  show: string
}

const TOAST_DISPLAY_TIME = 4500;

export class Toast extends React.Component<ToastProps, ToastState> {
  constructor(props: ToastProps, context: any) {
    super(props, context)

    this.state = {
      show: 'false'
    }
  } 

  componentDidMount() {
    this.setState({...this.state, show: this.props.show}, () => {
      const el = document.querySelector('#js--lt-toast');
      if(el == null) return;
      
      setTimeout(() => {
          el.classList.add('show');
          el.classList.add('animate');

          setTimeout(() => {
            this.setState({...this.state, show: 'false'});
            setCookie(PREF_BRANCH_COOKIE_TOAST, 'false', 1);
            el.classList.remove('show');
          }, TOAST_DISPLAY_TIME);
      }, 100);
    });
  }

  componentWillUnmount() {
    setCookie(PREF_BRANCH_COOKIE_TOAST, 'false', 1);
  }

  render() {
    return (
      <div id="js--lt-toast" className='location-toast lt'>
        <div className="lt__inner container-fluid ">
          <p className="lt__message">Voorkeur opgeslagen</p>
        </div>
      </div>
    )
  }
}
